import { render, staticRenderFns } from "./DropShadowTIcon.vue?vue&type=template&id=70bd4098&"
import script from "./DropShadowTIcon.vue?vue&type=script&lang=js&"
export * from "./DropShadowTIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports